// Helpers for the `active` flag of countries (1: active, 0: inactive).
// Kept free of Vue dependencies so they can be reused in other apps.

// A country is inactive only when `active` is explicitly 0.
// Missing `active` (e.g. stale data in sessionStorage) counts as active.
function isActiveCountry(country) {
  return !!country && Number(country.active) !== 0
}

// Countries offered in selects: all for locked applications (so stored
// inactive values still display), only active ones for editable applications.
function selectableCountries(countries, applicationFinalSaved) {
  const list = countries || []
  return applicationFinalSaved ? list : list.filter(isActiveCountry)
}

function findCountryById(countries, id) {
  if (id === null || id === undefined || id === '') return undefined
  return (countries || []).find(country => country.id === id)
}

// Name comparison ignores surrounding spaces and letter case.
function normalizeName(name) {
  return String(name)
    .trim()
    .toUpperCase()
}

function findCountryByName(countries, name) {
  if (!name) return undefined
  const target = normalizeName(name)
  return (countries || []).find(
    country => country.name && normalizeName(country.name) === target
  )
}

function isInactiveCountryId(countries, id) {
  const country = findCountryById(countries, id)
  return !!country && !isActiveCountry(country)
}

// A name that is not found in the (loaded) list is treated as not available,
// like an inactive one. An empty value or a not yet loaded list is not.
function isInactiveCountryName(countries, name) {
  if (!name || !countries || countries.length === 0) return false
  const country = findCountryByName(countries, name)
  return !country || !isActiveCountry(country)
}

export {
  isActiveCountry,
  selectableCountries,
  findCountryById,
  findCountryByName,
  isInactiveCountryId,
  isInactiveCountryName,
}
